import { Avatar } from 'antd'
import React from 'react'

import s from './website-tab.module.less'

export const WebsiteTab: React.FC<{ avatarSrc?: string; title: string; link: string }> = ({
  avatarSrc,
  title,
  link,
}) => {
  return (
    <div className={s.linkTab} onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}>
      <Avatar
        className={s.avatar}
        size={40}
        style={{ backgroundColor: avatarSrc ? undefined : '#1890ff', color: 'white' }}
        src={avatarSrc}
      >
        {title[0]}
      </Avatar>
      <a className={s.name}>{title}</a>
    </div>
  )
}
